import React from "react";

export interface PictureTextInfo {
    title: string;
    address: string;
    time: string;
    picture: string;
    content: string;
    className?: string;
}


export class PictureText extends React.Component<PictureTextInfo> {
    render() {
        return (
            <>
                <div className={this.props.className + " pictureText"}>
                    <div className="item">
                        <div className="img"><img src={this.props.picture}></img></div>
                        <div className="content">
                            <div className="title">{this.props.title}</div>
                            <div className="address">{this.props.address}</div>
                            <div className="time">{this.props.time}</div>
                            <div className="content">{this.props.content}</div>
                        </div>
                    </div>
                    <hr></hr>
                </div>
            </>
        )
    }
}